module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "describe"
  }, [_c('p', [_vm._v("会员总人数")]), _vm._v(" "), _c('countTo', {
    staticClass: "count",
    attrs: {
      "startVal": 0,
      "endVal": 3424089,
      "duration": 5000
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "map"
  }, [_c('div', {
    class: _vm.list[0] ? 'itemactive' : 'item'
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mark"
  })]), _vm._v(" "), _c('div', {
    class: _vm.list[1] ? 'item2active' : 'item2'
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "mark"
  })]), _vm._v(" "), _c('div', {
    class: _vm.list[2] ? 'item3active' : 'item3'
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "mark"
  })])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('centerBottom')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("辽宁大连-中山广场店")]), _vm._v(" "), _c('p', [_vm._v("\"大转盘\"活动-进行中2019/10-20-2019/12/30")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("新增会员数：7834")]), _vm._v(" "), _c('li', [_vm._v("新增公众号关注人数：2324")]), _vm._v(" "), _c('li', [_vm._v("会员复购率：30.51%，环比提升3.21%")]), _vm._v(" "), _c('li', [_vm._v("活动访问人数：16931")]), _vm._v(" "), _c('li', [_vm._v("扫码产品数：17087")]), _vm._v(" "), _c('li', [_vm._v("中奖人数：896")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("重庆-解放路店")]), _vm._v(" "), _c('p', [_vm._v("\"大转盘\"活动-进行中2019/11-10-2020/2/30")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("新增会员数：3912")]), _vm._v(" "), _c('li', [_vm._v("新增公众号关注人数：2892")]), _vm._v(" "), _c('li', [_vm._v("会员复购率：29.56%，环比提升4.88%")]), _vm._v(" "), _c('li', [_vm._v("活动访问人数：9768")]), _vm._v(" "), _c('li', [_vm._v("扫码产品数：10231")]), _vm._v(" "), _c('li', [_vm._v("中奖人数：5435")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("浙江杭州-西湖店")]), _vm._v(" "), _c('p', [_vm._v("\"微信红包\"活动-进行中 2019/10-25-2019/12/15")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("新增会员数：6323")]), _vm._v(" "), _c('li', [_vm._v("新增公众号关注人数：3421")]), _vm._v(" "), _c('li', [_vm._v("会员复购率：25.24%，环比提升5.67%")]), _vm._v(" "), _c('li', [_vm._v("活动访问人数：13242")]), _vm._v(" "), _c('li', [_vm._v("扫码产品数：13532")]), _vm._v(" "), _c('li', [_vm._v("中奖人数：543")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animate wave"
  }, [_c('div', {
    staticClass: "w1"
  }), _vm._v(" "), _c('div', {
    staticClass: "w2"
  }), _vm._v(" "), _c('div', {
    staticClass: "w3"
  }), _vm._v(" "), _c('div', {
    staticClass: "w4"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-74562572!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/runda/yinxiao/components/center/index.vue
// module id = 2041
// module chunks = 2